/* eslint-disable func-names */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
import angular from 'angular';
import cianPhotoTransfer from '@cian/ui/app/components/photo-transfer/index.jsm';
// eslint-disable-next-line max-len
import angularDragAndDropLists from '@cian/ui/app/adapters/angular-drag-and-drop-lists/angular-drag-and-drop-lists.module.jsm';
import template from './photo-upload.jade';
import uiCianButton from '@cian/ui/app/components/button/index.jsm';
import uiCianIcon from '@cian/ui/app/components/icon/index.jsm';
import uiCianPreloader from '@cian/ui/app/components/preloader/index.jsm';
import './photo-upload.styl';
import piexifjs from 'piexifjs';

// TEST COMMENT

const PHOTOS_UPDATED = 'cianUiPhotoUpload:PHOTOS_UPDATED';

function applyTransform(ctx, orientation, width, height) {
  switch (orientation) {
    case 2:
      return ctx.transform(-1, 0, 0, 1, width, 0);
    case 3:
      return ctx.transform(-1, 0, 0, -1, width, height);
    case 4:
      return ctx.transform(1, 0, 0, -1, 0, height);
    case 5:
      return ctx.transform(0, 1, 1, 0, 0, 0);
    case 6:
      return ctx.transform(0, 1, -1, 0, height, 0);
    case 7:
      return ctx.transform(0, -1, -1, 0, height, width);
    case 8:
      return ctx.transform(0, -1, 1, 0, 0, width);
    default:
      return 0;
  }
}

function restoreExif(orig, res) {
  try {
    const exifObj = piexifjs.load(orig.$ngfDataUrl);
    exifObj['0th'][piexifjs.ImageIFD.Orientation] = 1;
    const exifbytes = piexifjs.dump(exifObj);
    return piexifjs.insert(exifbytes, res);
  } catch (e) {
    return res;
  }
}

export default angular
  .module('cian.ui.photo-upload', [
    cianPhotoTransfer,
    angularDragAndDropLists,
    uiCianButton,
    uiCianIcon,
    uiCianPreloader,
  ])

  .service('PhotoUploadService', function () {
    const errorListeners = [];

    this.addError = errorObj => errorListeners.forEach(listener => listener.call(null, errorObj));
    this.onError = handler => angular.isFunction(handler) && errorListeners.push(handler);
  })

  .factory('PhotoList', [
    'PhotoUploadService',
    'PhotoTransfer',
    'Upload',
    'UploadExif',
    'logger',
    '$rootScope',
    '$q', (
      PhotoUploadService,
      PhotoTransfer,
      Upload,
      UploadExif,
      logger,
      $rootScope,
      $q,
    ) => {
    UploadExif.applyExifRotation = file => {
      if (file.type.indexOf('image/jpeg') !== 0) {
        return UploadExif.emptyPromise(file);
      }

      const deferred = $q.defer();
      UploadExif.readOrientation(file).then(result => {
        if (result.orientation < 2 || result.orientation > 8) {
          return deferred.resolve(file);
        }
        return UploadExif.dataUrl(file, true).then(url => {
          const canvas = document.createElement('canvas');
          const img = document.createElement('img');

          img.onload = () => {
            try {
              canvas.width = result.orientation > 4 ? img.height : img.width;
              canvas.height = result.orientation > 4 ? img.width : img.height;
              const ctx = canvas.getContext('2d');
              if (!ctx) {
                deferred.reject();
              }
              applyTransform(ctx, result.orientation, img.width, img.height);
              ctx.drawImage(img, 0, 0);
              let dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
              // Здесь модифицировали, было так
              // dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
              dataUrl = restoreExif(file, dataUrl);
              const blob = UploadExif.dataUrltoBlob(dataUrl, file.name);
              return deferred.resolve(blob);
            } catch (e) {
              return deferred.reject(e);
            }
          };
          img.onerror = () => {
            deferred.reject();
          };
          img.src = url;
        }, e => {
          deferred.reject(e);
        });
      }, e => {
        deferred.reject(e);
      });
      return deferred.promise;
    };

    class PhotoList {
      static rotateDegree = 90;

      static create({
        type,
        name,
        id = null,
        fullUrl = null,
        url = null,
        size = 0,
        rotateDegree = 0,
        isDefault = false,
        isLayout = false,
        hasModerationViolation = false,
        $ngfWidth = null,
        $ngfHeight = null,
      }) {
        return {
          type,
          name,
          id,
          fullUrl,
          url,
          size,
          rotateDegree,
          isDefault,
          $ngfWidth,
          $ngfHeight,
          isVisible: true,
          isLayout,
          hasModerationViolation,
        };
      }

      constructor(uploadUrl,
        photos = []) {
        this.listeners = [];
        this.selectedPhoto = null;
        this.outsideClickListener = null;
        this.uploadUrl = uploadUrl;
        this.setup(photos);
        this.photosInQueue = 0;
        this.hasLayoutDefault = false;
      }

      update(photo) {
        if (photo.thumbnailUrl && !photo.url) {
          photo.url = photo.thumbnailUrl;
        } else if (photo.fullUrl && !photo.url) {
          photo.url = photo.fullUrl;
        } else if (photo.id && !photo.url) {
          // id есть только у фото, которые загружены на сервер
          photo.url = photo.url || `${this.uploadUrl}${photo.id}`;
        } else if (!photo.url) {
          // photo.url = photo.$ngfBlobUrl || photo.$ngfDataUrl;

          const updatedPhoto = PhotoList.create(photo);

          // TODO сначала отдаём updatedPhoto объект, потом изменяем его поля; неочевидно, надо переделать
          // dataUrl возвращает ссылку на blob, можно указать в качестве img(src) эту ссылку
          Upload.dataUrl(photo).then(url => {
            updatedPhoto.url = url;
          });

          // загружается файл
          this.photosInQueue += 1;
          this.upload(photo).then(response => {
            if (response && response.data && response.data.id) {
              updatedPhoto.id = response.data.id;
              this.notify();
            } else {
              logger.error('Fail to upload image. Invalid response');
              PhotoUploadService.addError({ $error: 'uploadError' });
              updatedPhoto.isRejected = true;
              this.notify();
            }
          })
          .catch(() => {
            PhotoUploadService.addError({ $error: 'uploadError' });
            updatedPhoto.isRejected = true;
            this.notify();
          })
          .finally(() => {
            this.photosInQueue -= 1;

            // upload complete notify
            if (this.photosInQueue === 0) {
              $rootScope.$emit(PHOTOS_UPDATED);
            }
          });

          this.sort();

          // файл подменяется объектом фото
          return updatedPhoto;
        }

        return photo;
      }

      upload(photo) {
        return PhotoTransfer.upload(photo, this.uploadUrl);
      }

      hasDefault() {
        return this.photos.reduce((result, photo) => result || photo.isDefault, false);
      }

      setDefault(id) {
        if (id) {
          this.photos.forEach(photo => photo.isDefault = photo.id === id);
        } else {
          this.photos.reduce((result, photo) => {
            if (!result && photo.id) {
              photo.isDefault = true;
              return true;
            }

            return result;
          }, false);
        }
      }

      add(...photos) {
        if (!photos) {
          return;
        }

        let layoutDefaultId = null;

        photos.forEach(file => {
          const photo = PhotoList.create(file);
          if (file.isLayout && file.isDefault) {
            this.hasLayoutDefault = true;
            layoutDefaultId = file.id;
            this.photos.unshift(photo);
          } else {
            this.photos.push(photo);
          }
          this.update(photo);
        });

        if (this.hasLayoutDefault) {
          this.setDefault(layoutDefaultId);
        }
        if (!this.hasDefault()) {
          this.setDefault();
        }
      }

      find(id) {
        return this.photos.filter(photo => photo.id === id)[0];
      }

      index(photo) {
        return this.photos.indexOf(photo);
      }

      rotate(id) {
        const photo = this.find(id);
        photo.rotateDegree = (photo.rotateDegree + PhotoList.rotateDegree) % 360;
      }

      splice(index) {
        const photo = this.photos[index];

        if (!photo) {
          return;
        }

        this.photos.splice(index, 1);

        if (!this.hasDefault()) {
          this.setDefault();
        }
      }

      hide(index) {
        this.photos[index].isVisible = false;
      }

      show() {
        this.photos.forEach(photo => photo.isVisible = true);
      }

      remove(id) {
        const photo = this.find(id);
        const index = this.index(photo);

        if (index !== -1) {
          this.splice(index, 1);
          $rootScope.$emit(PHOTOS_UPDATED);
        }
      }

      setup(photos = []) {
        this.photos = [];
        this.add(...photos);
      }

      listen(callback) {
        this.listeners.push(callback);
      }

      notify() {
        this.removeRejected();
        this.listeners.forEach(callback => callback());
      }

      addLayout(layout) {
        if (layout.id && this.find(layout.id)) {
          const photo = this.find(layout.id);
          photo.isLayout = true;
          this.sort();
        } else {
          const copy = PhotoList.create(layout);
          copy.isLayout = true;

          this.add(copy);
          this.notify();
        }
      }

      sort(files) {
        const target = files || this.photos;
        const photos = target.filter(photo => !photo.isLayout);
        const layouts = target.filter(photo => photo.isLayout);
        const sorted = [...photos, ...layouts];

        if (!files) {
          this.photos = sorted;
          this.notify();
        } else {
          return sorted;
        }

        return undefined;
      }

      removeRejected() {
        this.photos = this.photos.filter(photo => !photo.isRejected);
      }

      get model() {
        return this.photos
          .filter(photo => photo.id)
          .map(({ id, isDefault, rotateDegree }) => ({ id, isDefault, rotateDegree }));
      }
    }

    return PhotoList;
  }])

  .config([ '$provide', function($provide) {
    $provide.decorator('Upload', [
      '$delegate',
      function $logDecorator($delegate) {
        $delegate.isFile = function decorateIsFile(file) {
          return file != null && (file instanceof window.Blob || file instanceof window.File || (file.flashId && file.name && file.size));
        };

        return $delegate;
      },
    ]);
  }])

  .directive('cianUiPhotoUpload', ['PhotoList', PhotoList => ({
    scope: {},
    bindToController: {
      model: '=',
      cuiInvalid: '=',
      cuiRequired: '=',
      uploadUrl: '=',
      minCount: '=',
      errors: '=',
    },
    require: ['ngModel', 'cianUiPhotoUpload'],
    link(scope, el, attr, ctrls) {
      ctrls[1].init(ctrls[0]);

      // todo fix for CSSSR-1049, get rid of it
      scope.photoUpload.forceRepaint = () => {
        const style = el[0].style;

        if (style) {
          const transform = style.transform;
          style.transform = 'translateZ(0)';
          const offset = el[0].offsetHeight; // eslint-disable-line
          style.transform = transform;
        }
      };
    },
    controller: [
      'PhotoUploadService',
      '$rootScope',
      '$timeout',
      '$uibModal',
      'deviceService', function (
        PhotoUploadService,
        $rootScope,
        $timeout,
        $uibModal,
        deviceService,
      ) {
        const layoutUploadEvent = 'layoutUpload';
        const layoutRemoveEvent = 'layoutRemove';

        this.init = ngModel => {
          this.isMobile = deviceService.isMobile;
          this.minCount = this.minCount || 0;

          this.list = new PhotoList(this.uploadUrl, this.model || []);
          this.list.listen(() => this.updateModel());

          this.updateModel = () => {
            this.model = this.list.model;
            ngModel.$validate();
          };

          this.updateModel();

          this.onChange = () => {
            this.updateModel();
          };

          this.onMoved = index => {
            this.list.splice(index);
            this.list.sort();
            this.forceRepaint();
          };

          this.onDrag = index => this.list.hide(index);
          this.onDrop = () => this.list.show();

          this.remove = (id, $event) => {
            const photo = this.list.find(id);

            if (this.errors && angular.isArray(this.errors)) {
              this.errors = this.errors.filter(error => error.url !== photo.url);
            }

            const isLayout = this.list.find(id).isLayout;

            $event.stopPropagation();
            this.list.remove(id);
            this.updateModel();

            if (isLayout) {
              $rootScope.$emit(layoutRemoveEvent, { id });
            }
            this.forceRepaint();
          };

          this.onSelect = () => {
            this.updateModel();
          };

          this.setDefault = id => {
            this.list.setDefault(id);
            this.updateModel();
          };

          this.showPhoto = photo => {
            $uibModal.open({
              windowClass: 'cui-photo-upload__preview',
              template: `<img class='cui-photo-upload__preview-photo' ng-src=${photo.url}>`,
              controller: ['$uibModalInstance', '$window', '$scope', ($uibModalInstance, $window, $scope) => {
                function closeModal() {
                  $uibModalInstance.dismiss();
                  $window.removeEventListener('click', closeModal);
                }
                $window.addEventListener('click', closeModal);
                $scope.$on('$destroy', () => {
                  $window.removeEventListener('click', closeModal);
                });
              }],
            });
          };

          this.addOutsideClickListener = selectedPhoto => {
            const outsideClickHandler = event => {
              if (!selectedPhoto.contains(event.target)) {
                selectedPhoto.classList.remove('mobile-clicked');
                this.selectedPhoto = null;
                this.removeOutsideClickListener();
              }
            };

            document.addEventListener('click', outsideClickHandler);
            this.outsideClickListener = outsideClickHandler;
          };

          this.removeOutsideClickListener = () => {
            document.removeEventListener('click', this.outsideClickListener);
          };

          this.handlePhotoSelect = selectedPhoto => {
            selectedPhoto.classList.add('mobile-clicked');
            this.selectedPhoto = selectedPhoto;
            this.addOutsideClickListener(selectedPhoto);
          };

          this.handleSelectedPhotoClick = () => {
            this.selectedPhoto = null;
            this.removeOutsideClickListener();
          };

          this.removeMobileClass = target => {
            target.classList.remove('mobile-clicked');
          };

          this.handlePhotoClick = ({ currentTarget }) => {
            if (this.selectedPhoto) {
              this.removeMobileClass(this.selectedPhoto);
            }

            if (this.selectedPhoto === currentTarget) {
              this.handleSelectedPhotoClick(currentTarget);
            } else {
              this.handlePhotoSelect(currentTarget);
            }
          };

          this.rotate = id => {
            this.list.rotate(id);
            this.updateModel();
          };

          this.getPhotoClass = photo => {
            return `cui-photo-upload__photo_rotate_${photo.rotateDegree} ${
              photo.hasModerationViolation ? 'cui-photo-upload__photo_not_active' : ''
            }`;
          };

          this.layoutUploadEventHandler = $rootScope.$on(layoutUploadEvent, (event, layout) => {
            this.list.addLayout(layout);
          });

          this.layoutRemoveEventHandler = $rootScope.$on(layoutRemoveEvent, (event, { id }) => {
            this.list.remove(id);
            this.updateModel();
            this.forceRepaint();
          });

          ngModel.$isEmpty = value => !value || !value.length;

          ngModel.$validators.required = value => value && value.length;
          ngModel.$validators.minCount = value => value && value.length >= this.minCount;

          ngModel.$parsers.push(photos => {
            ngModel.$setTouched();

            this.errors = photos.filter(photo => photo.$error);

            photos.forEach(photo => {
              if (
                !photo.$error &&
                (photo.$ngfHeight > 200 && photo.$ngfWidth > 200) &&
                !(photo.$ngfHeight >= 600 && photo.$ngfWidth >= 800 ||
                  photo.$ngfHeight >= 800 && photo.$ngfWidth >= 600)
              ) {
                photo.$warning = 'badWH';
                this.errors.push(photo);
              }
            });

            const errorKeys = Object.keys(ngModel.$error);
            errorKeys.forEach(key => ngModel.$setValidity(key, !ngModel.$validators[key] || !ngModel.$error[key]));

            photos = photos
              .filter(photo => !photo.$error)
              .map(photo => this.list.update(photo));

            if (photos.length && !photos.filter(photo => photo.isDefault).length) {
              photos[0].isDefault = true;
            }

            photos = this.list.sort(photos);

            return photos;
          });
        };

        const errorTimeouts = {};

        const addError = errorObj => {
          this.errors = [...this.errors, errorObj];
        };

        const removeErrorByCode = errorCode => {
          this.errors = this.errors.filter(error => error.$error !== errorCode);
        };

        PhotoUploadService.onError(errorObj => {
          const errorCode = errorObj.$error || 'defaultError';
          errorObj.$error = errorCode;
          const errorVisibleTime = errorObj.timeout || 5000;

          if (errorTimeouts[errorCode]) {
            removeErrorByCode(errorCode);
            $timeout.cancel(errorTimeouts[errorCode]);
          }

          addError(errorObj);
          errorTimeouts[errorCode] = $timeout(() => {
            removeErrorByCode(errorCode);
          }, errorVisibleTime);
        });
      },
    ],
    controllerAs: 'photoUpload',
    replace: true,
    template,
  })])
  .name;
